<template>
  <div id="tableCHILD" class="TableListItem tableYHZ" v-if="childs">
    <ul class="LeftSideNav">
      <template v-for="(child, c_index) in childs" :key="c_index">
        <li @click="cur_key = c_index" :class="{ current: cur_key == c_index }">
          {{ child['child'].name }}
        </li>
      </template>
    </ul>

    <div class="TableContents">
      <!-- 基础 -->
      <equ :one_child="one_child" />
      <!-- 神通start -->
      <basic  :one_child="one_child" />
      <!-- 化神start -->
      <attr :one_child="one_child" />
    </div>
  </div>

  <div id="tableYHZ" class="TableListItem" v-else>
    <div class="none-tips">该角色未吸收任何元魂珠</div>
  </div>
</template>

<script setup>

import equ from './child_c/equ.vue';
import basic from './child_c/basic.vue';
import attr from './child_c/attr.vue';

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

const cur_key = ref(0);

const childs = computed(() => {
  return props.role_data?.childs || {};
});

const one_child = computed(() => {
  return childs.value[cur_key.value] || {};
});
</script>
